import { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { cancelSubscription } from '@/lib/apis';
import { usePostHog } from 'posthog-js/react';

interface CancelSubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  organizationId: number;
  onSuccess: () => void;
}

export function CancelSubscriptionModal({
  isOpen,
  onClose,
  organizationId,
  onSuccess,
}: CancelSubscriptionModalProps) {
  const posthog = usePostHog();
  const [loading, setLoading] = useState(false);

  const handleCancel = async () => {
    setLoading(true);
    try {
      await cancelSubscription(organizationId);
      posthog?.capture('subscription_cancelled');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('  ** Failed to cancel subscription:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Subscription</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to cancel your SMB subscription? Your subscription will remain active 
            until the end of your current billing period, and you'll continue to have access to all features 
            during this time.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose} disabled={loading}>
            Keep Subscription
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleCancel}
            disabled={loading}
            className="bg-red-600 hover:bg-red-700"
          >
            {loading ? 'Canceling...' : 'Cancel Subscription'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}